import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './material.module';
import { MatSelectFilterModule } from 'mat-select-filter';
import { RecruiterRoutingModule } from 'src/routes/recruiter-routing.module';
import { RecruiterComponent } from 'src/views/recruiter/recruiter.component';
import { FilterDialogComponent } from 'src/components/filter-dialog/filter-dialog.component';
import { CandidateEditDialogComponent } from 'src/components/candidate-edit-dialog/candidate-edit-dialog.component';
import { RecruiterSearchComponent } from 'src/components/recruiter-search/recruiter-search.component';
import { ProcessListComponent } from 'src/components/process-list/process-list.component'
import { SelectionTestComponent } from 'src/components/selection-test/selection-test.component';
import { SelectionTestDialogComponent } from 'src/components/selection-test-dialog/selection-test-dialog.component';
import { ProcessListService } from 'src/services/process-list.service';
import { CreateProcessListDialogComponent } from 'src/components/create-process-list-dialog/create-process-list-dialog.component';
import { CreateProcessListComponent } from 'src/components/create-process-list/create-process-list.component';
import { ProcessListNameDialogComponent } from 'src/components/process-list-name-dialog/process-list-name-dialog.component'
import { UsersComponent } from 'src/components/users/users.component';
import { UserDialogComponent } from 'src/components/user-dialog/user-dialog.component';
import { CompanyAccountComponent } from 'src/components/company-account/company-account.component';
import { ProcessListSelectionTestDialogComponent } from 'src/components/process-list-selection-test-dialog/process-list-selection-test-dialog.component'
import { QuestionResponseCorrectionDialogComponent } from 'src/components/question-response-correction-dialog/question-response-correction-dialog.component';
import { ProcessListInterviewDialogComponent } from 'src/components/process-list-interview-dialog/process-list-interview-dialog.component';
import { ProcessListInterviewEvaluatedDialogComponent } from 'src/components/process-list-interview-evaluated-dialog/process-list-interview-evaluated-dialog.component';
import { ProcessListMultipleSelectionTestDialogComponent } from 'src/components/process-list-multiple-selection-test-dialog/process-list-multiple-selection-test-dialog.component';
import { ProcessListCandidatePointsDialogComponent } from 'src/components/process-list-candidate-points-dialog/process-list-candidate-points-dialog.component';
import { ProcessListInterviewSessionDialogComponent } from 'src/components/process-list-interview-session-dialog/process-list-interview-session-dialog.component';
import { NgxMaskModule } from 'ngx-mask';
import { VoucherComponentComponent } from 'src/components/voucher-component/voucher-component.component';
import { AnalyticsComponent } from 'src/components/analytics/analytics.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { MdePopoverModule } from '@material-extended/mde';
import { AnalyticsSegmentDialogComponent } from 'src/components/analytics-segment-dialog/analytics-segment-dialog.component';
import { ProfessionalExperiencesViewsDialogComponent } from 'src/components/professional-experiences-views-dialog/professional-experiences-views-dialog.component';
import { PaineladmComponent } from 'src/components/paineladm/paineladm.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ProcessListViewDialogComponent } from 'src/components/process-list-view-dialog/process-list-view-dialog.component';
import { UtmsReportComponent } from 'src/components/analytics/utms-report/utms-report.component';
import { SearchDialogComponent } from 'src/components/search-dialog/search-dialog.component';
import { ProcessListUnarchiveDialogComponent } from 'src/components/process-list-unarchive-dialog/process-list-unarchive-dialog.component';
import { SinonimoReportComponent } from 'src/components/analytics/sinonimo-report/sinonimo-report.component';
import { DesiredJobTitleReportComponent } from 'src/components/analytics/desired-job-title-report/desired-job-title-report.component';
import { RegisterStepsReportComponent } from 'src/components/analytics/register-steps-report/register-steps-report.component';
import { ApproveRecruitersComponent } from 'src/components/approve-recruiters/approve-recruiters.component';
import { FilledFieldsReportComponent } from 'src/components/analytics/filled-fields-report/filled-fields-report.component';
import { CompaniesReportComponent } from 'src/components/analytics/companies-report/companies-report.component';
import { LoginReportComponent } from 'src/components/analytics/login-report/login-report.component';
import { QuestionTestDialogComponent } from 'src/components/question-test-dialog/question-test-dialog.component';
import { NewInterviewComponent } from 'src/components/new-interview/new-interview.component';
import { SharedModule } from './shared.module';
import { ProcessListShareDialogComponent } from 'src/components/process-list-share-dialog/process-list-share-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        RecruiterRoutingModule,
        NgxMaskModule.forChild(),
        NgxChartsModule,
        MdePopoverModule,
        NgxSkeletonLoaderModule
            .forRoot({
                theme: {
                    height: '20px'
                },
            }),
        MatSelectFilterModule,
        SharedModule
    ],
    declarations: [
        RecruiterComponent,
        FilterDialogComponent,
        CandidateEditDialogComponent,
        //RecruiterReportComponent,
        RecruiterSearchComponent,
        PaineladmComponent,
        ProcessListComponent,
        SelectionTestComponent,
        SelectionTestDialogComponent,
        CreateProcessListDialogComponent,
        CreateProcessListComponent,
        ProcessListNameDialogComponent,
        UsersComponent,
        UserDialogComponent,
        CompanyAccountComponent,
        ProcessListSelectionTestDialogComponent,
        QuestionResponseCorrectionDialogComponent,
        ProcessListInterviewDialogComponent,
        ProcessListInterviewEvaluatedDialogComponent,
        ProcessListMultipleSelectionTestDialogComponent,
        ProcessListCandidatePointsDialogComponent,
        ProcessListInterviewSessionDialogComponent,
        VoucherComponentComponent,
        AnalyticsComponent,
        AnalyticsSegmentDialogComponent,
        ProfessionalExperiencesViewsDialogComponent,
        ProcessListViewDialogComponent,
        UtmsReportComponent,
        SinonimoReportComponent,
        DesiredJobTitleReportComponent,
        RegisterStepsReportComponent,
        SearchDialogComponent,
        ProcessListUnarchiveDialogComponent,
        ApproveRecruitersComponent,
        CompaniesReportComponent,
        LoginReportComponent,
        FilledFieldsReportComponent,
        QuestionTestDialogComponent,
        NewInterviewComponent,
        ProcessListShareDialogComponent,
    ],
    providers: [
        ProcessListService,
        DatePipe
    ]
})
export class RecruiterModule {

}